import { useMutation, useQueryClient } from '@tanstack/react-query';
import { jobPositionService } from '../services/jobPosition.service';
import type { JobPosition } from '../types/jobPosition.types';
import { JobPositionId } from '@/shared/types/branded.types';

interface UseArchiveJobPositionReturn {
  archiveJobPosition: (
    params: { id: string; archive: boolean },
    options?: { onSuccess?: () => void; onError?: () => void }
  ) => void;
  archiveJobPositionAsync: (params: { id: string; archive: boolean }) => Promise<JobPosition>;
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
  error: Error | null;
}

export function useArchiveJobPosition(): UseArchiveJobPositionReturn {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({ id, archive }: { id: string; archive: boolean }) =>
      archive
        ? jobPositionService.archive(JobPositionId(id))
        : jobPositionService.unarchive(JobPositionId(id)),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['job-positions'] });
      queryClient.invalidateQueries({ queryKey: ['job-position'] });
    },
  });

  return {
    archiveJobPosition: mutation.mutate,
    archiveJobPositionAsync: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
  };
}
